export default __webpack_public_path__ + "static/media/rs.21387c6a.svg";